import apiClient from '@/clients/apiClient';

export const getSettlements = (
  page = 1,
  pageSize = 50,
  search = '',
  status = '',
  partnerId = '',
  from = '',
  to = ''
) =>
  apiClient.get(
    `settlements?Page=${page}&PageSize=${pageSize}&Search=${search}&Status=${status}&PartnerId=${partnerId}&From=${from}&To=${to}`
  );

export const getSettlementSummary = () => apiClient.get('settlements/summary');

export const getSettlementDetail = (id) => apiClient.get(`settlements/${id}`);

export const initiateSettlement = (settlementIds) =>
  apiClient.post('settlements/initiate', { settlementIds });
